import { render, staticRenderFns } from "./ObjectRelationAttributeRow.vue?vue&type=template&id=9b934e92&scoped=true&"
import script from "./ObjectRelationAttributeRow.vue?vue&type=script&lang=ts&"
export * from "./ObjectRelationAttributeRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b934e92",
  null
  
)

export default component.exports